import { render, staticRenderFns } from "./wyModalAddGoal.vue?vue&type=template&id=53a20396&"
import script from "./wyModalAddGoal.vue?vue&type=script&lang=js&"
export * from "./wyModalAddGoal.vue?vue&type=script&lang=js&"
import style0 from "./wyModalAddGoal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports